module.exports = __webpack_public_path__ + "static/img/00011B_X_3_4_5_20170731_fit.760a255.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/00011B_X_3_4_5_20170731_fit.png
// module id = ER/2
// module chunks = 0